// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 获取订单详情 获取订单详情 GET /api/v1/app/order/rent-to-buy/${param0} */
export async function AppRentToBuyOrderControllerGetOrderDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerGetOrderDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputAppOrderDetailDto>(
    `/api/v1/app/order/rent-to-buy/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 取消订单 取消订单 POST /api/v1/app/order/rent-to-buy/${param0}/cancel */
export async function AppRentToBuyOrderControllerCancelV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerCancelV1Params,
  body: MyApi.CancelOrderDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCancelOrderDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/cancel`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 确认收货 确认收货 POST /api/v1/app/order/rent-to-buy/${param0}/confirm-receipt */
export async function AppRentToBuyOrderControllerConfirmReceiptV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerConfirmReceiptV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/app/order/rent-to-buy/${param0}/confirm-receipt`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 创建合同代扣签约 注册拍小租用户（如需）并创建合同代扣订单，返回签约链接；同时落库签约与代扣计划信息 POST /api/v1/app/order/rent-to-buy/${param0}/create-pxz-sign */
export async function AppRentToBuyOrderControllerCreatePxzSignV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerCreatePxzSignV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCreatePxzSignDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/create-pxz-sign`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 信用免押 信用免押 POST /api/v1/app/order/rent-to-buy/${param0}/credit-free */
export async function AppRentToBuyOrderControllerPayCreditFreeV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerPayCreditFreeV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseString>(
    `/api/v1/app/order/rent-to-buy/${param0}/credit-free`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 下载签署文件 下载签署文件 GET /api/v1/app/order/rent-to-buy/${param0}/esign-download-file */
export async function AppRentToBuyOrderControllerDownloadEsignFileV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerDownloadEsignFileV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseEsignSignedFilesDownloadDataDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/esign-download-file`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 获取e签宝签署链接 获取e签宝签署链接 GET /api/v1/app/order/rent-to-buy/${param0}/esign-sign-url */
export async function AppRentToBuyOrderControllerGetEsignSignUrlV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerGetEsignSignUrlV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseEsignSignUrlDataDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/esign-sign-url`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** E签宝发起签署流程 E签宝发起签署流程 POST /api/v1/app/order/rent-to-buy/${param0}/esign-start-sign */
export async function AppRentToBuyOrderControllerEsignStartSignV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerEsignStartSignV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStartEsignFlowDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/esign-start-sign`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询签署流程状态 查询签署流程状态 GET /api/v1/app/order/rent-to-buy/${param0}/esign-status */
export async function AppRentToBuyOrderControllerGetEsignStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerGetEsignStatusV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputSyncEsignFlowStatusDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/esign-status`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 获取赋强公证公证书链接 获取赋强公证公证书链接 GET /api/v1/app/order/rent-to-buy/${param0}/notary-cert-url */
export async function AppRentToBuyOrderControllerGetNotaryCertUrlV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerGetNotaryCertUrlV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseString>(
    `/api/v1/app/order/rent-to-buy/${param0}/notary-cert-url`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询公证结果 查询公证结果 GET /api/v1/app/order/rent-to-buy/${param0}/notary-result */
export async function AppRentToBuyOrderControllerGetNotaryResultV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerGetNotaryResultV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseNotaryInfoDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/notary-result`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 主动支付账单 用户主动在线支付指定期分期账单（租金/分期/续租/逾期费）。全部账单结清后：短租分期（productType=installment）进入待归还；以租代购（rent_to_buy）自动完成订单。后台人工入账/扣款结清时以租代购不自动完成，需管理员确认。 POST /api/v1/app/order/rent-to-buy/${param0}/pay-bill */
export async function AppRentToBuyOrderControllerPayBillV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerPayBillV1Params,
  body: MyApi.PayBillDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCreateGatewayPaymentResultDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/pay-bill`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 支付押金 手动在线支付押金（与信用免押二选一） POST /api/v1/app/order/rent-to-buy/${param0}/pay-deposit */
export async function AppRentToBuyOrderControllerPayDepositV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerPayDepositV1Params,
  body: MyApi.PayDepositDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCreateGatewayPaymentResultDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/pay-deposit`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 支付订单 支付订单 POST /api/v1/app/order/rent-to-buy/${param0}/pay-order */
export async function AppRentToBuyOrderControllerPayOrderV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerPayOrderV1Params,
  body: MyApi.PayOrderDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputCreateGatewayPaymentResultDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/pay-order`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 查询支付账单结果 查询指定期分期账单支付结果并同步订单状态 GET /api/v1/app/order/rent-to-buy/${param0}/query-pay-bill-result */
export async function AppRentToBuyOrderControllerQueryPayBillResultV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerQueryPayBillResultV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputQueryGatewayPaymentResultDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/query-pay-bill-result`,
    {
      method: "GET",
      params: {
        // paymentProvider has a default value: cpcnpay
        paymentProvider: "cpcnpay",
        // platform has a default value: alipay
        platform: "alipay",
        ...queryParams,
      },
      ...(options || {}),
    }
  );
}

/** 查询支付押金结果 查询手动押金支付结果并同步订单状态 GET /api/v1/app/order/rent-to-buy/${param0}/query-pay-deposit-result */
export async function AppRentToBuyOrderControllerQueryPayDepositResultV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerQueryPayDepositResultV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputQueryGatewayPaymentResultDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/query-pay-deposit-result`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询订单支付结果 查询订单支付结果 GET /api/v1/app/order/rent-to-buy/${param0}/query-payment */
export async function AppRentToBuyOrderControllerQueryPaymentV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerQueryPaymentV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputQueryGatewayPaymentResultDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/query-payment`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 续租订单 短租使用中或待归还均可提前续租：须最后一期分期/续租账单已支付；确认后立即延长租期并创建续租账单，用户可前往支付计划付款 POST /api/v1/app/order/rent-to-buy/${param0}/renewal */
export async function AppRentToBuyOrderControllerRenewalOrderV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerRenewalOrderV1Params,
  body: MyApi.RenewOrderDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputRenewOrderDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/renewal`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 设置订单押金状态为支付中状态 设置订单押金状态为支付中状态 POST /api/v1/app/order/rent-to-buy/${param0}/set-deposit-paying-status */
export async function AppRentToBuyOrderControllerSetDepositPayingStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerSetDepositPayingStatusV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/app/order/rent-to-buy/${param0}/set-deposit-paying-status`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 设置分期账单支付记录为支付中状态 设置分期账单支付记录为支付中状态 POST /api/v1/app/order/rent-to-buy/${param0}/set-pay-bill-record-paying-status */
export async function AppRentToBuyOrderControllerSetPayBillRecordPayingStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerSetPayBillRecordPayingStatusV1Params,
  body: MyApi.SetPayBillRecordPayingStatusDto,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/app/order/rent-to-buy/${param0}/set-pay-bill-record-paying-status`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      params: { ...queryParams },
      data: body,
      ...(options || {}),
    }
  );
}

/** 设置订单为支付中状态 设置订单为支付中状态 POST /api/v1/app/order/rent-to-buy/${param0}/set-paying-status */
export async function AppRentToBuyOrderControllerSetPayingStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerSetPayingStatusV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/app/order/rent-to-buy/${param0}/set-paying-status`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 赋强公证发起 赋强公证发起 POST /api/v1/app/order/rent-to-buy/${param0}/start-notary-flow */
export async function AppRentToBuyOrderControllerStartNotaryFlowV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerStartNotaryFlowV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputStartNotaryFlowDto>(
    `/api/v1/app/order/rent-to-buy/${param0}/start-notary-flow`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 查询免押结果并且同步订单状态 查询免押结果并且同步订单状态 GET /api/v1/app/order/rent-to-buy/${param0}/sync-credit-free-result */
export async function AppRentToBuyOrderControllerSyncCreditFreeResultV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerSyncCreditFreeResultV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseString>(
    `/api/v1/app/order/rent-to-buy/${param0}/sync-credit-free-result`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 同步拍小租签约状态 C 端主动同步拍小租签约与代扣计划状态；须为当前用户订单，逻辑与管理端一致 POST /api/v1/app/order/rent-to-buy/${param0}/sync-pxz-sign-status */
export async function AppRentToBuyOrderControllerSyncPxzSignStatusV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerSyncPxzSignStatusV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseBoolean>(
    `/api/v1/app/order/rent-to-buy/${param0}/sync-pxz-sign-status`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 用户端上传凭证 用户端上传凭证 POST /api/v1/app/order/rent-to-buy/${param0}/upload-certificate */
export async function AppRentToBuyOrderControllerUploadCertificateV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerUploadCertificateV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseString>(
    `/api/v1/app/order/rent-to-buy/${param0}/upload-certificate`,
    {
      method: "POST",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 获取用户待付款、待收货、租赁中、已逾期的订单数量 获取用户待付款、待收货、租赁中、已逾期的订单数量 GET /api/v1/app/order/rent-to-buy/count */
export async function AppRentToBuyOrderControllerGetOrderCountV1(options?: {
  [key: string]: any;
}) {
  return request<MyApi.ApiResponseOutputAppOrderCountDto>(
    "/api/v1/app/order/rent-to-buy/count",
    {
      method: "GET",
      ...(options || {}),
    }
  );
}

/** 创建分期订单/短租订单 创建分期订单/短租订单 POST /api/v1/app/order/rent-to-buy/create */
export async function AppRentToBuyOrderControllerCreateV1(
  body: MyApi.CreateRentToBuyOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputCreateRentToBuyOrderDto>(
    "/api/v1/app/order/rent-to-buy/create",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}

/** App 用户端订单列表分页查询 查询当前登录用户的分期商品订单，支持 Tab 筛选与关键字搜索 GET /api/v1/app/order/rent-to-buy/list */
export async function AppRentToBuyOrderControllerListV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppRentToBuyOrderControllerListV1Params,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputAppOrderListItemDtoArray>(
    "/api/v1/app/order/rent-to-buy/list",
    {
      method: "GET",
      params: {
        // pageSize has a default value: 10
        pageSize: "10",

        // tab has a default value: all
        tab: "all",
        ...params,
      },
      ...(options || {}),
    }
  );
}
